// src/components/WelcomeMessage.jsx
import React, { useEffect, useState } from 'react';
import { Message, Icon } from 'semantic-ui-react';

const WelcomeMessage = ({ user, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [shouldRender, setShouldRender] = useState(true);

    useEffect(() => {
        // Trigger slide-in animation after mount
        const slideTimer = setTimeout(() => setIsVisible(true), 10);
        
        // Auto-hide after 3 seconds
        const hideTimer = setTimeout(() => {
            setIsVisible(false);
            setTimeout(() => {
                setShouldRender(false);
                if (onClose) onClose();
            }, 300); // Wait for fade-out animation
        }, 3000);

        return () => {
            clearTimeout(slideTimer);
            clearTimeout(hideTimer);
        };
    }, [onClose]);

    if (!shouldRender) return null;

    const username = user?.name || user?.email?.split('@')[0] || 'User';

    return (
        <>
            <style>{`
                .tb-welcome-toast {
                    position: fixed;
                    top: 80px;
                    right: 20px;
                    z-index: 1000;
                    max-width: 380px;
                    opacity: 0;
                    transform: translateX(120%);
                    transition: opacity 0.3s cubic-bezier(0.2, 0.0, 0.0, 1),
                                transform 0.3s cubic-bezier(0.2, 0.0, 0.0, 1);
                }
                .tb-welcome-toast.tb-toast-visible {
                    opacity: 1;
                    transform: translateX(0);
                }
                @media (max-width: 768px) {
                    .tb-welcome-toast {
                        right: 10px;
                        left: 10px;
                        max-width: none;
                        transform: translateY(-120%);
                    }
                    .tb-welcome-toast.tb-toast-visible {
                        transform: translateY(0);
                    }
                }
            `}</style>
            <div className={`tb-welcome-toast ${isVisible ? 'tb-toast-visible' : ''}`}>
                <Message 
                    success 
                    onDismiss={onClose}
                    style={{
                        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
                        borderRadius: '10px',
                        border: 'none',
                        margin: 0
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                        <Icon 
                            name='check circle' 
                            style={{ 
                                marginTop: '2px',
                                fontSize: '1.2em',
                                color: '#6F9911'
                            }} 
                        />
                        <div style={{ flex: 1 }}>
                            <Message.Header style={{ marginBottom: '0.25rem', fontSize: '1.1em' }}>
                                Welcome back, {username}!
                            </Message.Header>
                            <p style={{ 
                                marginTop: '0.25rem', 
                                marginBottom: 0,
                                fontSize: '0.95em',
                                color: 'rgba(0,0,0,0.7)'
                            }}>
                                You have successfully signed in to tenantBridge.
                            </p>
                        </div>
                    </div>
                </Message>
            </div>
        </>
    );
};

export default WelcomeMessage;

